import React from 'react';
export function FooterSection() {
  return <footer className="bg-black border-t border-zinc-900 py-12" data-id="element-140">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-141">
        <div className="text-2xl font-black text-white tracking-widest uppercase mb-6" data-id="element-142">
          Roseta <span className="text-yellow-500" data-id="element-143">Digital</span>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mb-8" data-id="element-144">
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-145">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-146">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-yellow-500 transition-colors" data-id="element-147">
            Contacto
          </a>
        </div>

        <p className="text-xs text-gray-600 max-w-2xl leading-relaxed mb-4" data-id="element-148">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>

        <p className="text-xs text-gray-500" data-id="element-149">
          &copy; {new Date().getFullYear()} Roseta Digital. Todos los derechos
          reservados.
        </p>
      </div>
    </footer>;
}